export const BROWSER_SESSION_ID_KEY = 'browser-session-id';